import React, { Fragment } from 'react';
import { arrayOf, bool, shape, func, string } from 'prop-types';
import classnames from 'classnames';

import Button from '@johnlewispartnership/wtr-ingredients/ingredients/Button';
import AddButton from '@johnlewispartnership/wtr-ingredients/ingredients/AddButton';

import { notRequiredAddressSchema as addressSchema, setModalRoute } from 'components/Address/util';
import { AddButton as AddButtonFormField } from 'components/Forms/ReduxFormFields';
import AddressTile from 'components/Address/common/AddressTile';
import { ChooseAddressModal, AddAddressButton } from 'components/Address/common';

import urls from 'constants/urls';

import styles from './ChooseAddress.scss';

const chooseAddressDefaultPropAddresses = [];
const chooseAddressDefaultPropOnAfterSelect = () => {};
const chooseAddressDefaultPropValidate = [];
const chooseAddressDefaultPropReportChangeAddressClick = () => {};

const ChooseAddress = ({
  addresses = chooseAddressDefaultPropAddresses,
  initialChosenAddress,
  addressChosenFromModal,
  modalTitle = 'Change Address',
  addAddressTitle = 'Add Address',
  editAddressTitle = 'Edit Address',
  buttonMessage = 'Change Address',
  ukOnlyAddress = false,
  manualOnly = true,
  displayAddressTile = true,
  ignoreMyWaitroseAddressCustomizations = false,
  ignoreContactAddressCustomizations = false,
  loadChooseAddress,
  onAfterSelect = chooseAddressDefaultPropOnAfterSelect,
  validate = chooseAddressDefaultPropValidate,
  reportChangeAddressClick = chooseAddressDefaultPropReportChangeAddressClick,
}) => {
  const AddButtonOfType = validate.length !== 0 ? AddButtonFormField : AddButton;
  const addAddressOnly = addresses.length === 0;

  return (
    <Fragment>
      {addAddressOnly ? (
        <AddAddressButton
          showAsLink={false}
          onClick={() => {
            loadChooseAddress(addresses);
          }}
          buttonMessage={buttonMessage}
          validate={validate}
          name="choose-address"
          id="choose-address"
        />
      ) : (
        <Fragment>
          {displayAddressTile && (addressChosenFromModal || initialChosenAddress) ? (
            <Fragment>
              <div className="row">
                <div className="col-xs-12of12" data-test="selected-address">
                  <AddressTile
                    address={addressChosenFromModal ?? initialChosenAddress}
                    isEditable={false}
                    optionsLoading={false}
                    showContactNumber={false}
                    ignoreMyWaitroseAddressCustomizations={ignoreMyWaitroseAddressCustomizations}
                    ignoreContactAddressCustomizations={ignoreContactAddressCustomizations}
                  />
                </div>
              </div>
              <div className="row">
                <div className={classnames('col-xs-12of12', styles.chooseAddressButton)}>
                  <Button
                    data-testid="load-choose-address"
                    label={buttonMessage}
                    onClick={() => {
                      reportChangeAddressClick();
                      loadChooseAddress(addresses);
                      setModalRoute(urls.addressModals.choose);
                    }}
                    theme="secondary"
                    width="fit"
                  />
                </div>
              </div>
            </Fragment>
          ) : (
            <AddButtonOfType
              data-testid="load-choose-address"
              onClick={() => {
                loadChooseAddress(addresses);
                setModalRoute(urls.addressModals.choose);
              }}
              label={buttonMessage}
              validate={validate}
              name="choose-address"
              id="choose-address"
            />
          )}
        </Fragment>
      )}
      <ChooseAddressModal
        pageTitle={modalTitle}
        onAfterSelect={onAfterSelect}
        ukOnlyAddress={ukOnlyAddress}
        addAddressTitle={addAddressTitle}
        editAddressTitle={editAddressTitle}
        manualOnly={manualOnly}
      />
    </Fragment>
  );
};

ChooseAddress.propTypes = {
  addresses: arrayOf(shape(addressSchema)),
  initialChosenAddress: shape(addressSchema),
  addressChosenFromModal: shape(addressSchema),
  modalTitle: string,
  addAddressTitle: string,
  editAddressTitle: string,
  buttonMessage: string,
  ukOnlyAddress: bool,
  manualOnly: bool,
  displayAddressTile: bool,
  ignoreMyWaitroseAddressCustomizations: bool,
  ignoreContactAddressCustomizations: bool,
  loadChooseAddress: func.isRequired,
  onAfterSelect: func,
  validate: arrayOf(func),
  reportChangeAddressClick: func,
};

export default ChooseAddress;
